import { render, staticRenderFns } from "./UserAddEmail.vue?vue&type=template&id=0163c9a1"
import script from "./UserAddEmail.vue?vue&type=script&lang=js"
export * from "./UserAddEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports